var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWagonEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #353535;\n      }\n\n      .b {\n        fill: none;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wagon_empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    y: 15,
    width: 25,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 25,
    height: 17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagonEmpty);
export default __webpack_public_path__ + "static/media/wagon_empty.dcee12a02284e6db431bd0b52e95e004.svg";
export { ForwardRef as ReactComponent };